import React from 'react'

const ReusableNewCompany = ({register, name=false}) => {
  return (
    <>
    <div className="mt-4 font-Laila border-2 border-primary-blue">
    <div className="flex-col flex md:flex-row flex-wrap">
      <div className="flex flex-1  border-b md:border-r items-center m-0 px-2 border-primary-blue">
        <label className="border-primary-blue flex-shrink-0 border-l-0 text-primary-red  text-lg font-bold">
          कम्पनी नाम :
        </label>
        <input
          type="text"
          placeholder=" "
          // name="company_name"
          {...register("company_name", { required: false, })}
          
         

          className=" text-primary-blue w-[60%] m-0  py-3 px-3 outline-none"
        />
      </div>
      <div className="flex flex-1 flex-wrap w-fit  border-b  px-2 items-center border-primary-blue">
        <label className="border-primary-blue flex-shrink-0 border-l-0 text-primary-red  text-lg font-bold">
          कम्पनीको ठेगाना :
        </label>
        <input
          type="text"
          placeholder=""
          // name="address"
          {...register("company_address", { required: false, })}

          className=" text-primary-blue w-[60%] flex-shrink-0 m-0  py-3 px-3 outline-none"
        />
      </div>
    </div>
    <div className="flex-col flex md:flex-row flex-wrap">
      <div className="flex flex-1  border-b md:border-r items-center m-0 px-2 border-primary-blue">
        <label className="border-primary-blue flex-shrink-0  text-primary-red  text-lg font-bold">
          सम्बन्धित ब्यक्तीको नाम :
        </label>
        <input
          type="text"
          placeholder=" "
          // name="company_name"
          {...register("owner_name", { required: false, })}
          className=" text-primary-blue w-[60%] m-0  py-3 px-3 outline-none"
        />
      </div>
      <div className="flex flex-1 flex-wrap w-fit  border-b  px-2 items-center border-primary-blue">
        <label className="border-primary-blue flex-shrink-0 border-l-0 text-primary-red  text-lg font-bold">
         सम्बन्धित ब्यक्तीको ठेगाना :
        </label>
        <input
          type="text"
          placeholder=""
          // name="address"
          {...register("owner_address", { required: false, })}
          className=" text-primary-blue w-[60%] flex-shrink-0 m-0  py-3 px-3 outline-none"
        />
      </div>
    </div>
    <div className="flex-col flex md:flex-row flex-wrap">
      <div className="flex flex-1  border-b md:border-r items-center m-0 px-2 border-primary-blue">
        <label className="border-primary-blue flex-shrink-0  text-primary-red  text-lg font-bold">
          सम्बन्धित व्यक्तीको सम्पर्क नं.:
        </label>
        <input
          type="text"
          placeholder=" "
          name="company_name"
          {...register("company_name", { required: false })}
          className=" text-primary-blue w-[60%] m-0  py-3 px-3 outline-none"
        />
      </div>
      <div className="flex flex-1 flex-wrap w-fit  border-b  px-2 items-center border-primary-blue">
        <label className="border-primary-blue flex-shrink-0 border-l-0 text-primary-red  text-lg font-bold">
        शेयर सदस्यहरुको संख्या :
        </label>
        <input
          type="text"
          placeholder=""
          name="address"
          className=" text-primary-blue w-[60%] flex-shrink-0 m-0  py-3 px-3 outline-none"
          {...register("share_member", { required: false })}
          
        />
      </div>
    </div>
    <div className="flex-col flex md:flex-row flex-wrap">
      <div className="flex flex-1  border-b md:border-r items-center m-0 px-2 border-primary-blue">
        <label className="border-primary-blue flex-shrink-0 border-l-0 text-primary-red  text-lg font-bold">
          कम्पनीको Username:
        </label>
        <input
          type="text"
          placeholder=" "
          name="company_name"
          {...register("username", { required: false })}
          className=" text-primary-blue w-[60%] m-0  py-3 px-3 outline-none"
        />
      </div>
      <div className="flex flex-1 flex-wrap w-fit border-b px-2 items-center border-primary-blue">
        <label className="border-primary-blue flex-shrink-0 border-l-0 text-primary-red  text-lg font-bold">
          कम्पनीको Password:
        </label>
        <input
          type="text"
          placeholder=""
          name="address"
          {...register("password", { required: false })}
          className=" text-primary-blue w-[60%] flex-shrink-0 m-0  py-3 px-3 outline-none"
        />
      </div>
    </div>
    {
      name === false &&
    <>
    <div className=" bg-pink-100 border-primary-blue border-t">
      <p className="text-primary-blue mt-0 text-lg font-semibold leading-10 text-center">
        शेयर सदस्यहरुको संख्याको आधारमा ३ महिने विवरण पेश गर्दा तपाईको जम्मा
        लाग्ने रकम <span className='text-red-400'> रु.२०,०००।– </span> मात्र
      </p>
    </div>

  
    </>
}
  </div>
   <div className=" border-primary-blue text-primary-blue mt-3 font-Laila text-lg text-center">
    <span className=" text-primary-red mr-2">नोट :</span> माथी उल्लेखित रकम ७ जना सम्म शेयर सदस्यहरु भएमा मात्र लागु हुनेछ, यदि ७ जना भन्दा बढि भएमा प्रती सदस्य रु.५००।–को दरले थप शुल्क बृद्धि हुदै जानेछ ।
  
</div>
</>
  )
}

export default ReusableNewCompany